export default __webpack_public_path__ + "static/media/08_AtArmsLengthII.3c8ecf4a.jpg";